var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirefoxStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 47,
    viewBox: "0 0 130 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 41.9656C130 44.4966 128.326 46.5469 126.256 46.5469H3.7484C1.67941 46.5469 0 44.4966 0 41.9656V5.43105C0 2.90116 1.67941 0.84375 3.7484 0.84375H126.256C128.326 0.84375 129.999 2.90116 129.999 5.43105L130 41.9656Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5826 34.125V29.3325H56.5021V27.8329H51.5826V24.2068H56.9543V22.6754H49.8053V34.125H51.5826ZM58.3905 34.125H60.1123V25.5081H58.3905V34.125ZM59.2554 24.2782C59.8108 24.2782 60.2631 23.8339 60.2631 23.2864C60.2631 22.723 59.8108 22.2946 59.2554 22.2946C58.7 22.2946 58.2477 22.723 58.2477 23.2864C58.2477 23.8339 58.7 24.2782 59.2554 24.2782ZM61.9452 34.125H63.667V28.9834C63.667 27.7694 64.3811 26.9839 65.5157 26.9839C65.8569 26.9839 66.1584 27.0315 66.3013 27.087V25.4763C66.1664 25.4446 65.9521 25.4208 65.6982 25.4208C64.6826 25.4208 63.8892 26 63.6194 26.9601H63.5876V25.5081H61.9452V34.125ZM70.6256 26.8014C71.8793 26.8014 72.7283 27.6901 72.7679 29.031H68.396C68.4912 27.7059 69.3878 26.8014 70.6256 26.8014ZM72.76 31.6018C72.522 32.3556 71.7365 32.8317 70.7367 32.8317C69.3243 32.8317 68.3881 31.8478 68.3881 30.3561V30.2529H74.4897V29.6499C74.4897 27.0394 72.998 25.397 70.6335 25.397C68.2214 25.397 66.6504 27.1505 66.6504 29.8483C66.6504 32.546 68.2056 34.2281 70.705 34.2281C72.641 34.2281 74.1565 33.149 74.4025 31.6018H72.76ZM76.394 34.125H78.1079V26.8649H79.7504V25.5081H78.092V24.7701C78.1 24.0322 78.3936 23.7228 79.0997 23.7228C79.3298 23.7228 79.5679 23.7466 79.7424 23.7863V22.4771C79.4647 22.4294 79.1791 22.3977 78.8696 22.3977C77.124 22.3977 76.394 23.1039 76.394 24.7146V25.5081H75.2039V26.8649H76.394V34.125ZM84.519 34.2281C87.0105 34.2281 88.5895 32.5302 88.5895 29.8165C88.5895 27.1029 87.0026 25.397 84.519 25.397C82.0355 25.397 80.4407 27.1108 80.4407 29.8165C80.4407 32.5302 82.0276 34.2281 84.519 34.2281ZM84.519 32.7999C83.0591 32.7999 82.1863 31.697 82.1863 29.8165C82.1863 27.944 83.0591 26.8252 84.519 26.8252C85.979 26.8252 86.8439 27.936 86.8439 29.8165C86.8439 31.697 85.979 32.7999 84.519 32.7999ZM93.0011 30.9274L94.9292 34.125H96.8256L94.0167 29.761L96.8573 25.5081H94.9689L93.0725 28.6422H93.0328L91.1206 25.5081H89.1925L92.0251 29.8245L89.1608 34.125H91.0254L92.9614 30.9274H93.0011Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9905 16.3402V15.6528H52.323V16.5529H53.8341L53.8286 16.6511C53.8068 17.4857 53.1522 18.053 52.203 18.053C51.0738 18.053 50.3647 17.1966 50.3647 15.7947C50.3647 14.4146 51.0411 13.6018 52.1758 13.6018C52.9449 13.6018 53.5231 14.0109 53.7413 14.7037H54.936C54.7287 13.4436 53.6322 12.5926 52.1703 12.5926C50.3156 12.5926 49.1591 13.809 49.1591 15.8056C49.1591 17.8294 50.3156 19.0568 52.1921 19.0568C53.9486 19.0568 54.9905 18.0367 54.9905 16.3402ZM60.1892 17.9494H57.2216V16.2529H60.031V15.3146H57.2216V13.7054H60.1892V12.7017H56.0379V18.9531H60.1892V17.9494ZM64.0677 18.9531V13.7054H65.9933V12.7017H60.9638V13.7054H62.8894V18.9531H64.0677ZM70.6519 18.9531V16.4384H73.3139V15.4783H70.6519V13.7054H73.5649V12.7017H69.4682V18.9531H70.6519ZM77.3507 12.5926C75.4741 12.5926 74.3068 13.8363 74.3068 15.8274C74.3068 17.8185 75.4741 19.0568 77.3507 19.0568C79.2163 19.0568 80.3891 17.8185 80.3891 15.8274C80.3891 13.8363 79.2163 12.5926 77.3507 12.5926ZM77.3507 13.6127C78.4689 13.6127 79.1781 14.4691 79.1781 15.8274C79.1781 17.1857 78.4689 18.0421 77.3507 18.0421C76.2215 18.0421 75.5123 17.1857 75.5123 15.8274C75.5123 14.4691 76.2269 13.6127 77.3507 13.6127ZM82.5984 13.6563H83.8639C84.5731 13.6563 85.015 14.06 85.015 14.6928C85.015 15.3474 84.6004 15.7292 83.8858 15.7292H82.5984V13.6563ZM82.5984 16.6293H83.8258L85.064 18.9531H86.4169L85.0313 16.4438C85.7896 16.1711 86.226 15.4837 86.226 14.6655C86.226 13.4545 85.3968 12.7017 83.9949 12.7017H81.4146V18.9531H82.5984V16.6293Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3594 19.0585C37.7458 17.5821 36.5011 15.988 35.5264 15.4841C36.2216 16.8304 36.704 18.2764 36.9565 19.7705L36.9591 19.7941C35.3625 15.8135 32.6549 14.2084 30.4435 10.7134C30.3317 10.5367 30.2198 10.3596 30.1109 10.1727C30.0485 10.066 29.9986 9.96976 29.9553 9.88122C29.8636 9.70361 29.7929 9.51591 29.7447 9.32192C29.7447 9.31297 29.7415 9.3043 29.7356 9.29758C29.7297 9.29086 29.7215 9.28656 29.7126 9.28548C29.7039 9.28309 29.6947 9.28309 29.686 9.28548C29.6842 9.28548 29.6813 9.28876 29.6791 9.28949C29.6769 9.29022 29.6722 9.2935 29.6689 9.29496L29.6743 9.28548C26.1272 11.3624 24.9237 15.2071 24.813 17.1303C23.3964 17.2276 22.0421 17.7496 20.9267 18.6282C20.8103 18.5296 20.6887 18.4374 20.5623 18.352C20.2405 17.2257 20.2268 16.0337 20.5226 14.9004C19.22 15.5314 18.0625 16.426 17.1234 17.5274H17.1169C16.5572 16.818 16.5965 14.4788 16.6286 13.9902C16.463 14.0567 16.305 14.1406 16.1571 14.2405C15.6631 14.5931 15.2012 14.9888 14.7769 15.4229C14.2934 15.913 13.8519 16.4429 13.4568 17.0067V17.0089V17.0064C12.5489 18.2935 11.9049 19.7478 11.5621 21.2851L11.5432 21.3784C11.5166 21.5027 11.4207 22.125 11.4043 22.2602C11.4043 22.2707 11.4022 22.2806 11.4011 22.2911C11.2774 22.9336 11.2008 23.5843 11.1719 24.2379V24.3108C11.175 27.8467 12.5044 31.2528 14.8973 33.856C17.2903 36.4591 20.5727 38.0699 24.0959 38.3699C27.619 38.67 31.1266 37.6375 33.9253 35.4765C36.724 33.3156 38.6102 30.1833 39.2112 26.6989C39.2349 26.5167 39.2542 26.3363 39.2754 26.1523C39.5662 23.7483 39.2513 21.3097 38.3594 19.0585V19.0585ZM22.0832 30.1126C22.1491 30.1443 22.2111 30.1786 22.2788 30.2088L22.2887 30.215C22.2202 30.1822 22.1517 30.1481 22.0832 30.1126V30.1126ZM36.9602 19.7974V19.7839L36.9627 19.7989L36.9602 19.7974Z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3594 19.0593C37.7458 17.5829 36.5011 15.9888 35.5264 15.4849C36.2216 16.8312 36.704 18.2772 36.9565 19.7713V19.7847L36.9591 19.7997C38.0476 22.9144 37.8901 26.3293 36.5197 29.3307C34.9012 32.8035 30.9835 36.363 24.8512 36.1899C18.2253 36.0023 12.3899 31.0855 11.299 24.6457C11.1005 23.6303 11.299 23.1154 11.3989 22.2901C11.2627 22.9312 11.1867 23.5835 11.1719 24.2387V24.3116C11.175 27.8475 12.5044 31.2536 14.8973 33.8568C17.2903 36.4599 20.5727 38.0707 24.0959 38.3707C27.619 38.6708 31.1266 37.6383 33.9253 35.4773C36.724 33.3164 38.6102 30.1841 39.2112 26.6997C39.2349 26.5175 39.2542 26.3371 39.2754 26.1531C39.5662 23.7491 39.2513 21.3105 38.3594 19.0593V19.0593Z",
    fill: "url(#paint1_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3594 19.0593C37.7458 17.5829 36.5011 15.9888 35.5264 15.4849C36.2216 16.8312 36.704 18.2772 36.9565 19.7713V19.7847L36.9591 19.7997C38.0476 22.9144 37.8901 26.3293 36.5197 29.3307C34.9012 32.8035 30.9835 36.363 24.8512 36.1899C18.2253 36.0023 12.3899 31.0855 11.299 24.6457C11.1005 23.6303 11.299 23.1154 11.3989 22.2901C11.2627 22.9312 11.1867 23.5835 11.1719 24.2387V24.3116C11.175 27.8475 12.5044 31.2536 14.8973 33.8568C17.2903 36.4599 20.5727 38.0707 24.0959 38.3707C27.619 38.6708 31.1266 37.6383 33.9253 35.4773C36.724 33.3164 38.6102 30.1841 39.2112 26.6997C39.2349 26.5175 39.2542 26.3371 39.2754 26.1531C39.5662 23.7491 39.2513 21.3105 38.3594 19.0593V19.0593Z",
    fill: "url(#paint2_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4969 20.7192C31.5275 20.7407 31.5559 20.7622 31.5847 20.7837C31.23 20.1547 30.7884 19.5788 30.273 19.073C25.8839 14.6831 29.1227 9.55467 29.6689 9.29415L29.6743 9.28613C26.1273 11.363 24.9238 15.2078 24.813 17.1309C24.9777 17.1196 25.1409 17.1058 25.3093 17.1058C26.5678 17.1081 27.8034 17.4436 28.8902 18.0783C29.977 18.713 30.8764 19.6242 31.4969 20.7192V20.7192Z",
    fill: "url(#paint3_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3185 21.5955C25.2951 21.9468 24.0541 23.1583 23.6202 23.1583C19.6045 23.1583 18.9526 25.5875 18.9526 25.5875C19.1304 27.6331 20.5558 29.3179 22.2789 30.2091C22.3576 30.2499 22.4374 30.2867 22.5172 30.3228C22.6554 30.384 22.7937 30.4406 22.9319 30.4926C23.5232 30.7019 24.1426 30.8214 24.7694 30.8471C31.8078 31.1773 33.1713 22.4303 28.092 19.8921C29.2902 19.7362 30.5037 20.0309 31.497 20.7189C30.8765 19.6239 29.9771 18.7127 28.8903 18.078C27.8035 17.4433 26.5679 17.1078 25.3094 17.1055C25.1417 17.1055 24.9778 17.1193 24.8131 17.1306C23.3965 17.228 22.0422 17.75 20.9268 18.6285C21.1421 18.8107 21.3851 19.0541 21.8971 19.5587C22.8554 20.5028 25.313 21.4808 25.3185 21.5955V21.5955Z",
    fill: "url(#paint4_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3185 21.5955C25.2951 21.9468 24.0541 23.1583 23.6202 23.1583C19.6045 23.1583 18.9526 25.5875 18.9526 25.5875C19.1304 27.6331 20.5558 29.3179 22.2789 30.2091C22.3576 30.2499 22.4374 30.2867 22.5172 30.3228C22.6554 30.384 22.7937 30.4406 22.9319 30.4926C23.5232 30.7019 24.1426 30.8214 24.7694 30.8471C31.8078 31.1773 33.1713 22.4303 28.092 19.8921C29.2902 19.7362 30.5037 20.0309 31.497 20.7189C30.8765 19.6239 29.9771 18.7127 28.8903 18.078C27.8035 17.4433 26.5679 17.1078 25.3094 17.1055C25.1417 17.1055 24.9778 17.1193 24.8131 17.1306C23.3965 17.228 22.0422 17.75 20.9268 18.6285C21.1421 18.8107 21.3851 19.0541 21.8971 19.5587C22.8554 20.5028 25.313 21.4808 25.3185 21.5955V21.5955Z",
    fill: "url(#paint5_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2684 18.1595C20.3828 18.2324 20.4771 18.2958 20.5599 18.353C20.2381 17.2267 20.2244 16.0347 20.5201 14.9014C19.2175 15.5324 18.06 16.427 17.121 17.5284C17.1898 17.5266 19.2383 17.4898 20.2684 18.1595V18.1595Z",
    fill: "url(#paint6_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3009 24.6448C12.3907 31.0846 18.2271 36.0013 24.8531 36.189C30.9854 36.3624 34.9031 32.8026 36.5216 29.3298C37.892 26.3284 38.0495 22.9135 36.961 19.7987V19.7852C36.961 19.7747 36.9588 19.7685 36.961 19.7718L36.9635 19.7954C37.4645 23.0663 35.8009 26.2352 33.2 28.3781L33.192 28.3963C28.1244 32.5234 23.2747 30.8864 22.2931 30.2181C22.2246 30.1853 22.1561 30.1512 22.0876 30.1157C19.133 28.7034 17.9123 26.0115 18.174 23.7029C17.4726 23.7132 16.7833 23.52 16.1895 23.1465C15.5958 22.773 15.1231 22.2354 14.8287 21.5987C15.6043 21.1235 16.4887 20.8549 17.3975 20.8184C18.3063 20.7819 19.2094 20.9788 20.0206 21.3903C21.6929 22.1495 23.596 22.2243 25.3228 21.5987C25.3173 21.4839 22.8597 20.5056 21.9014 19.5619C21.3895 19.0572 21.1464 18.8142 20.9311 18.6317C20.8147 18.5331 20.6931 18.4409 20.5667 18.3555C20.4829 18.2983 20.3886 18.2363 20.2752 18.162C19.2452 17.4923 17.1967 17.5291 17.129 17.5309H17.1224C16.5627 16.8215 16.6021 14.4823 16.6341 13.9937C16.4686 14.0602 16.3105 14.1441 16.1627 14.244C15.6686 14.5966 15.2067 14.9923 14.7824 15.4263C14.2972 15.9151 13.8538 16.4437 13.4569 17.0066V17.0088V17.0062C12.549 18.2934 11.905 19.7476 11.5622 21.285C11.5553 21.3138 11.0535 23.5072 11.3009 24.6448V24.6448Z",
    fill: "url(#paint7_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2737 19.0723C30.7893 19.5787 31.2309 20.1552 31.5854 20.7848C31.6631 20.8435 31.7356 20.9018 31.7971 20.9583C34.9988 23.9096 33.3213 28.0816 33.1963 28.3786C35.7971 26.2358 37.4594 23.0669 36.9598 19.796C35.3625 15.8135 32.6549 14.2084 30.4435 10.7134C30.3317 10.5367 30.2198 10.3596 30.1109 10.1727C30.0485 10.066 29.9986 9.96976 29.9553 9.88122C29.8636 9.70361 29.7929 9.51591 29.7447 9.32192C29.7447 9.31297 29.7415 9.3043 29.7356 9.29758C29.7297 9.29086 29.7215 9.28656 29.7126 9.28548C29.7039 9.28309 29.6947 9.28309 29.686 9.28548C29.6842 9.28548 29.6813 9.28876 29.6791 9.28949C29.6769 9.29022 29.6722 9.2935 29.6689 9.29496C29.1227 9.55402 25.8839 14.6825 30.2737 19.0723V19.0723Z",
    fill: "url(#paint8_radial)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.795 20.957C31.7334 20.9005 31.6609 20.8422 31.5833 20.7836C31.5545 20.7621 31.5261 20.7406 31.4955 20.7191C30.5022 20.031 29.2887 19.7364 28.0905 19.8923C33.1697 22.432 31.807 31.1775 24.7678 30.8473C24.1411 30.8216 23.5217 30.7021 22.9303 30.4928C22.7921 30.4411 22.6539 30.3845 22.5157 30.323C22.4359 30.2866 22.3561 30.2501 22.2774 30.2093L22.2872 30.2155C23.2688 30.8856 28.1171 32.5227 33.1861 28.3937L33.1942 28.3755C33.3206 28.0803 34.9981 23.9073 31.795 20.957V20.957Z",
    fill: "url(#paint9_radial)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9526 25.5871C18.9526 25.5871 19.6044 23.1579 23.6201 23.1579C24.0541 23.1579 25.2962 21.9463 25.3184 21.5951C23.5916 22.2207 21.6886 22.1459 20.0162 21.3867C19.205 20.9752 18.302 20.7784 17.3931 20.8148C16.4843 20.8513 15.5999 21.1199 14.8243 21.5951C15.1187 22.2318 15.5914 22.7694 16.1852 23.1429C16.7789 23.5164 17.4682 23.7096 18.1696 23.6993C17.908 26.0083 19.1286 28.7002 22.0832 30.1121C22.1492 30.1438 22.2111 30.1781 22.2789 30.2083C20.5543 29.3174 19.1304 27.6326 18.9526 25.5871Z",
    fill: "url(#paint10_radial)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3594 19.0585C37.7458 17.5821 36.5011 15.988 35.5264 15.4841C36.2216 16.8304 36.704 18.2764 36.9565 19.7705L36.9591 19.7941C35.3625 15.8135 32.6549 14.2084 30.4435 10.7134C30.3317 10.5367 30.2198 10.3596 30.1109 10.1727C30.0485 10.066 29.9986 9.96976 29.9553 9.88122C29.8636 9.70361 29.7929 9.51591 29.7447 9.32192C29.7447 9.31297 29.7415 9.3043 29.7356 9.29758C29.7297 9.29086 29.7215 9.28656 29.7126 9.28548C29.7039 9.28309 29.6947 9.28309 29.686 9.28548C29.6842 9.28548 29.6813 9.28876 29.6791 9.28949C29.6769 9.29022 29.6722 9.2935 29.6689 9.29496L29.6743 9.28548C26.1272 11.3624 24.9237 15.2071 24.813 17.1303C24.9777 17.119 25.1409 17.1051 25.3092 17.1051C26.5678 17.1074 27.8034 17.443 28.8902 18.0777C29.977 18.7124 30.8764 19.6235 31.4969 20.7185C30.5036 20.0305 29.2901 19.7359 28.0919 19.8918C33.1712 22.4314 31.8084 31.1769 24.7693 30.8468C24.1425 30.8211 23.5231 30.7016 22.9318 30.4923C22.7935 30.4405 22.6553 30.3839 22.5171 30.3225C22.4373 30.286 22.3575 30.2496 22.2788 30.2088L22.2887 30.215C22.2202 30.1822 22.1517 30.1481 22.0832 30.1126C22.1491 30.1443 22.2111 30.1786 22.2788 30.2088C20.5543 29.3176 19.1303 27.6327 18.9525 25.5872C18.9525 25.5872 19.6044 23.158 23.6201 23.158C24.054 23.158 25.2961 21.9464 25.3184 21.5952C25.3129 21.4804 22.8552 20.5021 21.897 19.5584C21.385 19.0538 21.142 18.8107 20.9267 18.6282C20.8103 18.5296 20.6887 18.4374 20.5623 18.352C20.2405 17.2257 20.2268 16.0337 20.5226 14.9004C19.22 15.5314 18.0625 16.426 17.1234 17.5274H17.1169C16.5572 16.818 16.5965 14.4788 16.6286 13.9902C16.463 14.0567 16.305 14.1406 16.1571 14.2405C15.6631 14.5931 15.2012 14.9888 14.7769 15.4229C14.2934 15.913 13.8519 16.4429 13.4568 17.0067V17.0089V17.0064C12.5489 18.2935 11.9049 19.7478 11.5621 21.2851L11.5432 21.3784C11.5166 21.5027 11.3974 22.1337 11.3803 22.2693C11.3803 22.2795 11.3803 22.2587 11.3803 22.2693C11.2713 22.9207 11.2017 23.5781 11.1719 24.2379V24.3108C11.175 27.8467 12.5044 31.2528 14.8973 33.856C17.2903 36.4591 20.5727 38.0699 24.0959 38.3699C27.619 38.67 31.1266 37.6375 33.9253 35.4765C36.724 33.3156 38.6102 30.1833 39.2112 26.6989C39.2349 26.5167 39.2542 26.3363 39.2754 26.1523C39.5662 23.7483 39.2513 21.3097 38.3594 19.0585V19.0585ZM36.9584 19.7839L36.9609 19.7989L36.9584 19.7839Z",
    fill: "url(#paint11_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 36.4902,
    y1: 13.7978,
    x2: 13.0473,
    y2: 36.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4069 12.5182) scale(29.4396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6494 24.5539) scale(29.4396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1986 5.83705) scale(21.3278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3932 32.2432) scale(14.0175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2582 22.1408) rotate(-13.5916) scale(7.43199 8.70101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2778 11.3139) scale(10.0842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2042 4.91643) scale(43.0246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5779 7.30899) rotate(83.976) scale(31.5338 20.6953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0403 15.0485) scale(26.861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1308 16.6199) scale(29.3992)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 36.2085,
    y1: 13.6768,
    x2: 16.261,
    y2: 33.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxStore);
export default __webpack_public_path__ + "static/media/firefox-store.1fbd50d8658ea096f3cc538906c1e9f8.svg";
export { ForwardRef as ReactComponent };